// extracted by mini-css-extract-plugin
module.exports = {"container":"MainSection2_container__ZJ-ZS","inner_container":"MainSection2_inner_container__1jF0c","chart_container":"MainSection2_chart_container__uGfbv"};